import { Dialog } from 'primereact/dialog';
import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import { DashboardSkillAssessmentReportDetalQuery } from '../../../graphQLOperations/__generated__/DashboardSkillAssessmentReportDetalQuery.graphql';
import { getSkillAssessmentReportDetail } from '../../../graphQLOperations/Dashboard';
import { MaskedStudentData } from '../../MaskedData/MaskedStudentData';
import { PiiTypes } from '../../../analytics/dataMasking';

interface Props {
  visible: boolean;
  setVisible: (v: boolean) => void;
  queryReference: PreloadedQuery<DashboardSkillAssessmentReportDetalQuery> | unknown;
  dialogData: { name: string; headerType: string; publicUserId: string };
}
const SkillChallengeAttemptedDialog: FC<Props> = ({ visible, setVisible, queryReference, dialogData }) => {
  const queryData = usePreloadedQuery<DashboardSkillAssessmentReportDetalQuery>(
    getSkillAssessmentReportDetail,
    queryReference as PreloadedQuery<DashboardSkillAssessmentReportDetalQuery>,
  );

  return (
    <Dialog
      header={`${dialogData.headerType as string} Attempts`}
      visible={visible}
      onHide={() => {
        if (!visible) return;
        setVisible(false);
      }}
      style={{
        width: '40vw',
        height: `${queryData?.studentSkillAssessmentsReportDetail.length > 4 ? '32vh' : '30vh'}`,
      }}
      breakpoints={{ '1024px': '65vw', '641px': '100vw' }}
    >
      <div className="flex flex-column">
        <h3 className="font-bold">
          <MaskedStudentData type={PiiTypes.FullName} student={dialogData}>
            {dialogData.name}
          </MaskedStudentData>
          :
        </h3>
        <ul className="list-none p-0">
          {queryData?.studentSkillAssessmentsReportDetail &&
            queryData.studentSkillAssessmentsReportDetail.map((el, key) => (
              <li key={key}>
                {`${el.skillName} (${el.skillCode})`}{' '}
                {el.assessmentCount > 1 ? ` - ${el.assessmentCount} attempts` : ''}
              </li>
            ))}
        </ul>
      </div>
    </Dialog>
  );
};

export default SkillChallengeAttemptedDialog;
